import { useEffect } from 'react';
import { ChannelConfig } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useChannelConfig() {
  const channelConfig = useAxios(
    (axios, signal) =>
      axios.request<ChannelConfig>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/channel-config`,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    channelConfig.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return channelConfig;
}

export type ChannelConfigRequest = ReturnType<typeof useChannelConfig>;
